export const USER_INJECTION_KEY = Symbol('userContextKey')
export const THEME_INJECTION_KEY = Symbol('themeContextKey')
